import React, { createContext, useContext, useMemo } from "react";

/**
 * Contexto legado de mudança de rota.
 * O refresh de permissões fica em RouteChangeLoading (silencioso, por pathname).
 * Mantido para não quebrar imports de useRouteChange.
 */
export const RouteChangeContext = createContext({});

/**
 * @param {{ children: React.ReactNode }} props
 */
export const RouteChangeProvider = ({ children }) => {
    const value = useMemo(() => ({
        isLoading: false,
        setIsLoading: () => {},
    }), []);

    return (
        <RouteChangeContext.Provider value={value}>
            {children}
        </RouteChangeContext.Provider>
    );
};

/**
 * @returns {{ isLoading: boolean, setIsLoading: Function }}
 */
export const useRouteChange = () => {
    return useContext(RouteChangeContext);
};
